<template>
  <div>
    <v-select
      outlined
      v-model="duration"
      :items="state.durations"
      item-text="name"
      item-value="id"
      :menu-props="{ maxHeight: '400', zIndex: 13 }"
      label="Temps de préparation"
    ></v-select>
  </div>
</template>

<script>
import {
  computed,
  onMounted,
  reactive,
  set,
  watch,
} from "@vue/composition-api";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

import { URL_PARAM_NAMES } from "@/utils/constants";

const COMPONENT_NAME = "DurationFilter";

export default {
  name: COMPONENT_NAME,
  setup(props, { emit }) {
    const { store } = useProxy();
    const { axiosGet } = useAxios();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const state = reactive({
      durations: [],
    });

    // =>  METHODS

    // =>  COMPUTED
    const duration = computed({
      get: () => store.getters["marmiton/getDuration"],
      set(e) {
        store.dispatch("marmiton/updateDuration", e);
      },
    });

    // =>  WATCH
    watch(duration, (newValue) => {
      addQueryStringParam({
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: newValue,
        // is_multiple: false,
        is_integer: true,
        // is_boolean: false,
      });
    });

    // =>  HOOKS
    onMounted(async () => {
      const { data } = await axiosGet("/regie/marmiton/durations");
      set(state, "durations", data);

      await synchronizeFilterWithQueryString({
        dispatcher: "marmiton/updateDuration",
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: duration.value,
        // is_multiple: false,
        is_integer: true,
        // is_boolean: false,
        // dependsOn: undefined,
      });
    });

    // =>  DATA
    return {
      state,
      duration,
    };
  },
};
</script>

<style></style>
